import COLORS from '../styles/colors';

export const GLOBAL_STYLES = {
  body: {
    margin: 0,
    backgroundColor: COLORS.wildSand
  }
};
